import { Action } from '@reduxjs/toolkit'
import { profileStore } from '@entities/profile'
import { profileRepository } from '@entities/profile/model/domain'
import { of, filter, Observable, from, concat } from 'rxjs'
import { catchError, mergeMap } from 'rxjs/operators'
import { registerEpic } from '@shared/lib/redux'

const updateProfileEpic = (action$: Observable<Action>) =>
  action$.pipe(
    filter(profileStore.actions.updateProfileStart.match),
    mergeMap((_action) =>
      from(profileRepository.update()).pipe(
        mergeMap((response) =>
          concat(of(profileStore.actions.updateProfileSuccess(response)))
        ),
        catchError((error) =>
          of(profileStore.actions.updateProfileFailure(error as string))
        )
      )
    )
  )

registerEpic(updateProfileEpic)
